// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/*
* Ensure proper alignment of the vue material icons
*/
.material-design-icon[data-v-b7c7c7ca] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.modal-mask[data-v-b7c7c7ca] {
  --backdrop-color: 0, 0, 0;
  --icon-size: 20px;
  --slideshow-duration: var(--4d12a2e7);
  position: fixed;
  z-index: 9998;
  top: 0;
  inset-inline-start: 0;
  display: block;
  width: 100%;
  height: 100%;
  background-color: rgba(var(--backdrop-color), 0.5);
}
.modal-mask--opaque[data-v-b7c7c7ca] {
  background-color: rgba(var(--backdrop-color), 0.92);
}
.modal-mask--light[data-v-b7c7c7ca] {
  --backdrop-color: 255, 255, 255;
}
.modal-header[data-v-b7c7c7ca] {
  position: absolute;
  z-index: 10001;
  top: 0;
  inset-inline: 0 0;
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: var(--header-height);
  overflow: hidden;
  transition: opacity 250ms, visibility 250ms;
}
.modal-header__name[data-v-b7c7c7ca] {
  overflow-x: hidden;
  box-sizing: border-box;
  width: 100%;
  padding: 0 calc(var(--default-clickable-area) * 3) 0 12px;
  transition: padding ease 100ms;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 16px;
  margin-block: 0;
}
@media only screen and (min-width: 1024px) {
.modal-header__name[data-v-b7c7c7ca] {
    padding-inline-start: calc(var(--default-clickable-area) * 3);
    text-align: center;
}
}
.modal-header .icons-menu[data-v-b7c7c7ca] {
  position: absolute;
  inset-inline-end: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.modal-header .icons-menu .header-close[data-v-b7c7c7ca] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);
  padding: 0;
}
.modal-header .icons-menu .play-pause-icons[data-v-b7c7c7ca] {
  position: relative;
  width: var(--header-height);
  height: var(--header-height);
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: none;
  background-color: transparent;
}
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-b7c7c7ca],
.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-b7c7c7ca], .modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-b7c7c7ca],
.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-b7c7c7ca] {
  opacity: 1;
  border-radius: calc(var(--default-clickable-area) / 2);
  background-color: rgba(127, 127, 127, 0.25);
}
.modal-header .icons-menu .play-pause-icons__play[data-v-b7c7c7ca], .modal-header .icons-menu .play-pause-icons__pause[data-v-b7c7c7ca] {
  box-sizing: border-box;
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);
  cursor: pointer;
  opacity: 0.7;
}
.modal-header .icons-menu[data-v-b7c7c7ca]  .action-item {
  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);
}
.modal-header .icons-menu[data-v-b7c7c7ca]  .action-item--single {
  box-sizing: border-box;
  width: var(--default-clickable-area);
  height: var(--default-clickable-area);
  cursor: pointer;
  background-position: center;
  background-size: 22px;
}
.modal-header .icons-menu .header-actions[data-v-b7c7c7ca] button:focus-visible {
  box-shadow: none !important;
  outline: 2px solid #fff !important;
}
.modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle {
  padding: 0;
}
.modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle span, .modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle svg {
  width: var(--icon-size);
  height: var(--icon-size);
}
.modal-wrapper[data-v-b7c7c7ca] {
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* Navigation buttons */
  /* Content */
}
.modal-wrapper .prev[data-v-b7c7c7ca],
.modal-wrapper .next[data-v-b7c7c7ca] {
  z-index: 10000;
  height: 35vh;
  min-height: 300px;
  position: absolute;
  transition: opacity 250ms;
  color: white;
}
.modal-wrapper .prev[data-v-b7c7c7ca]:focus-visible,
.modal-wrapper .next[data-v-b7c7c7ca]:focus-visible {
  box-shadow: 0 0 0 2px var(--color-primary-element-text);
  background-color: var(--color-box-shadow);
}
.modal-wrapper .prev[data-v-b7c7c7ca] {
  inset-inline-start: 2px;
}
.modal-wrapper .next[data-v-b7c7c7ca] {
  inset-inline-end: 2px;
}
.modal-wrapper .modal-container[data-v-b7c7c7ca] {
  position: relative;
  display: flex;
  padding: 0;
  transition: transform 300ms ease;
  border-radius: var(--border-radius-container, var(--border-radius-rounded));
  background-color: var(--color-main-background);
  color: var(--color-main-text);
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);
}
.modal-wrapper .modal-container__close[data-v-b7c7c7ca] {
  z-index: 1;
  position: absolute;
  top: 4px;
  inset-inline-end: var(--default-grid-baseline);
}
.modal-wrapper .modal-container__content[data-v-b7c7c7ca] {
  width: 100%;
  min-height: 52px;
  overflow: auto;
}
.modal-wrapper--small > .modal-container[data-v-b7c7c7ca] {
  width: 400px;
  max-width: 90%;
  max-height: min(90%, 100% - 2 * var(--header-height));
}
.modal-wrapper--normal > .modal-container[data-v-b7c7c7ca] {
  max-width: 90%;
  width: 600px;
  max-height: min(90%, 100% - 2 * var(--header-height));
}
.modal-wrapper--large > .modal-container[data-v-b7c7c7ca] {
  max-width: 90%;
  width: 900px;
  max-height: min(90%, 100% - 2 * var(--header-height));
}
.modal-wrapper--full > .modal-container[data-v-b7c7c7ca] {
  width: 100%;
  height: calc(100% - var(--header-height));
  position: absolute;
  top: var(--header-height);
  border-radius: 0;
}
@media only screen and ((max-width: 512px) or (max-height: 400px)) {
.modal-wrapper .modal-container[data-v-b7c7c7ca] {
    max-width: initial;
    width: 100%;
    max-height: initial;
    height: calc(100% - var(--header-height));
    position: absolute;
    top: var(--header-height);
    border-radius: 0;
}
}

/* TRANSITIONS */
.fade-enter-active[data-v-b7c7c7ca],
.fade-leave-active[data-v-b7c7c7ca] {
  transition: opacity 250ms;
}
.fade-enter[data-v-b7c7c7ca],
.fade-leave-to[data-v-b7c7c7ca] {
  opacity: 0;
}
.fade-visibility-enter[data-v-b7c7c7ca],
.fade-visibility-leave-to[data-v-b7c7c7ca] {
  visibility: hidden;
  opacity: 0;
}
.modal-in-enter-active[data-v-b7c7c7ca],
.modal-in-leave-active[data-v-b7c7c7ca],
.modal-out-enter-active[data-v-b7c7c7ca],
.modal-out-leave-active[data-v-b7c7c7ca] {
  transition: opacity 250ms;
}
.modal-in-enter[data-v-b7c7c7ca],
.modal-in-leave-to[data-v-b7c7c7ca],
.modal-out-enter[data-v-b7c7c7ca],
.modal-out-leave-to[data-v-b7c7c7ca] {
  opacity: 0;
}
.modal-in-enter .modal-container[data-v-b7c7c7ca],
.modal-in-leave-to .modal-container[data-v-b7c7c7ca] {
  transform: scale(0.9);
}
.modal-out-enter .modal-container[data-v-b7c7c7ca],
.modal-out-leave-to .modal-container[data-v-b7c7c7ca] {
  transform: scale(1.1);
}
.modal-mask .play-pause-icons .progress-ring[data-v-b7c7c7ca] {
  position: absolute;
  top: 0;
  inset-inline-start: 0;
  transform: rotate(-90deg);
}
.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-b7c7c7ca] {
  transition: 100ms stroke-dashoffset;
  transform-origin: 50% 50%;
  animation: progressring-b7c7c7ca linear var(--slideshow-duration) infinite;
  stroke-linecap: round;
  stroke-dashoffset: 94.2477796077;
  stroke-dasharray: 94.2477796077;
}
.modal-mask .play-pause-icons--paused .icon-pause[data-v-b7c7c7ca] {
  animation: breath-b7c7c7ca 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-b7c7c7ca] {
  animation-play-state: paused !important;
}
@keyframes progressring-b7c7c7ca {
from {
    stroke-dashoffset: 94.2477796077;
}
to {
    stroke-dashoffset: 0;
}
}
@keyframes breath-b7c7c7ca {
0% {
    opacity: 1;
}
50% {
    opacity: 0;
}
100% {
    opacity: 1;
}
}`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/NcModal-Cy3UOuI2.css"],"names":[],"mappings":"AAAA;;;EAGE;AACF;;;EAGE;AACF;;CAEC;AACD;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,qCAAqC;EACrC,eAAe;EACf,aAAa;EACb,MAAM;EACN,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kDAAkD;AACpD;AACA;EACE,mDAAmD;AACrD;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,MAAM;EACN,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,WAAW;EACX,yDAAyD;EACzD,8BAA8B;EAC9B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;AACA;AACA;IACI,6DAA6D;IAC7D,kBAAkB;AACtB;AACA;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,wEAAwE;EACxE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;;;EAGE,UAAU;EACV,sDAAsD;EACtD,2CAA2C;AAC7C;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,wEAAwE;EACxE,eAAe;EACf,YAAY;AACd;AACA;EACE,wEAAwE;AAC1E;AACA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,qCAAqC;EACrC,eAAe;EACf,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;AACA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,YAAY;AACd;AACA;;EAEE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,YAAY;AACd;AACA;;EAEE,uDAAuD;EACvD,yCAAyC;AAC3C;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,gCAAgC;EAChC,2EAA2E;EAC3E,8CAA8C;EAC9C,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;EACd,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,cAAc;EACd,YAAY;EACZ,qDAAqD;AACvD;AACA;EACE,WAAW;EACX,yCAAyC;EACzC,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;AAEA,gBAAgB;AAChB;;EAEE,yBAAyB;AAC3B;AACA;;EAEE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;AACA;;;;EAIE,yBAAyB;AAC3B;AACA;;;;EAIE,UAAU;AACZ;AACA;;EAEE,qBAAqB;AACvB;AACA;;EAEE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,qBAAqB;EACrB,yBAAyB;AAC3B;AACA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,0EAA0E;EAC1E,qBAAqB;EACrB,gCAAgC;EAChC,+BAA+B;AACjC;AACA;EACE,mEAAmE;AACrE;AACA;EACE,uCAAuC;AACzC;AACA;AACA;IACI,gCAAgC;AACpC;AACA;IACI,oBAAoB;AACxB;AACA;AACA;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA;IACI,UAAU;AACd;AACA","sourcesContent":["/**\n * SPDX-FileCopyrightText: 2019 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/**\n * SPDX-FileCopyrightText: 2021 Nextcloud GmbH and Nextcloud contributors\n * SPDX-License-Identifier: AGPL-3.0-or-later\n */\n/*\n* Ensure proper alignment of the vue material icons\n*/\n.material-design-icon[data-v-b7c7c7ca] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.modal-mask[data-v-b7c7c7ca] {\n  --backdrop-color: 0, 0, 0;\n  --icon-size: 20px;\n  --slideshow-duration: var(--4d12a2e7);\n  position: fixed;\n  z-index: 9998;\n  top: 0;\n  inset-inline-start: 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(var(--backdrop-color), 0.5);\n}\n.modal-mask--opaque[data-v-b7c7c7ca] {\n  background-color: rgba(var(--backdrop-color), 0.92);\n}\n.modal-mask--light[data-v-b7c7c7ca] {\n  --backdrop-color: 255, 255, 255;\n}\n.modal-header[data-v-b7c7c7ca] {\n  position: absolute;\n  z-index: 10001;\n  top: 0;\n  inset-inline: 0 0;\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: var(--header-height);\n  overflow: hidden;\n  transition: opacity 250ms, visibility 250ms;\n}\n.modal-header__name[data-v-b7c7c7ca] {\n  overflow-x: hidden;\n  box-sizing: border-box;\n  width: 100%;\n  padding: 0 calc(var(--default-clickable-area) * 3) 0 12px;\n  transition: padding ease 100ms;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  font-size: 16px;\n  margin-block: 0;\n}\n@media only screen and (min-width: 1024px) {\n.modal-header__name[data-v-b7c7c7ca] {\n    padding-inline-start: calc(var(--default-clickable-area) * 3);\n    text-align: center;\n}\n}\n.modal-header .icons-menu[data-v-b7c7c7ca] {\n  position: absolute;\n  inset-inline-end: 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.modal-header .icons-menu .header-close[data-v-b7c7c7ca] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);\n  padding: 0;\n}\n.modal-header .icons-menu .play-pause-icons[data-v-b7c7c7ca] {\n  position: relative;\n  width: var(--header-height);\n  height: var(--header-height);\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__play[data-v-b7c7c7ca],\n.modal-header .icons-menu .play-pause-icons:hover .play-pause-icons__pause[data-v-b7c7c7ca], .modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__play[data-v-b7c7c7ca],\n.modal-header .icons-menu .play-pause-icons:focus .play-pause-icons__pause[data-v-b7c7c7ca] {\n  opacity: 1;\n  border-radius: calc(var(--default-clickable-area) / 2);\n  background-color: rgba(127, 127, 127, 0.25);\n}\n.modal-header .icons-menu .play-pause-icons__play[data-v-b7c7c7ca], .modal-header .icons-menu .play-pause-icons__pause[data-v-b7c7c7ca] {\n  box-sizing: border-box;\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);\n  cursor: pointer;\n  opacity: 0.7;\n}\n.modal-header .icons-menu[data-v-b7c7c7ca]  .action-item {\n  margin: calc((var(--header-height) - var(--default-clickable-area)) / 2);\n}\n.modal-header .icons-menu[data-v-b7c7c7ca]  .action-item--single {\n  box-sizing: border-box;\n  width: var(--default-clickable-area);\n  height: var(--default-clickable-area);\n  cursor: pointer;\n  background-position: center;\n  background-size: 22px;\n}\n.modal-header .icons-menu .header-actions[data-v-b7c7c7ca] button:focus-visible {\n  box-shadow: none !important;\n  outline: 2px solid #fff !important;\n}\n.modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle {\n  padding: 0;\n}\n.modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle span, .modal-header .icons-menu[data-v-b7c7c7ca] .action-item__menutoggle svg {\n  width: var(--icon-size);\n  height: var(--icon-size);\n}\n.modal-wrapper[data-v-b7c7c7ca] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  /* Navigation buttons */\n  /* Content */\n}\n.modal-wrapper .prev[data-v-b7c7c7ca],\n.modal-wrapper .next[data-v-b7c7c7ca] {\n  z-index: 10000;\n  height: 35vh;\n  min-height: 300px;\n  position: absolute;\n  transition: opacity 250ms;\n  color: white;\n}\n.modal-wrapper .prev[data-v-b7c7c7ca]:focus-visible,\n.modal-wrapper .next[data-v-b7c7c7ca]:focus-visible {\n  box-shadow: 0 0 0 2px var(--color-primary-element-text);\n  background-color: var(--color-box-shadow);\n}\n.modal-wrapper .prev[data-v-b7c7c7ca] {\n  inset-inline-start: 2px;\n}\n.modal-wrapper .next[data-v-b7c7c7ca] {\n  inset-inline-end: 2px;\n}\n.modal-wrapper .modal-container[data-v-b7c7c7ca] {\n  position: relative;\n  display: flex;\n  padding: 0;\n  transition: transform 300ms ease;\n  border-radius: var(--border-radius-container, var(--border-radius-rounded));\n  background-color: var(--color-main-background);\n  color: var(--color-main-text);\n  box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);\n}\n.modal-wrapper .modal-container__close[data-v-b7c7c7ca] {\n  z-index: 1;\n  position: absolute;\n  top: 4px;\n  inset-inline-end: var(--default-grid-baseline);\n}\n.modal-wrapper .modal-container__content[data-v-b7c7c7ca] {\n  width: 100%;\n  min-height: 52px;\n  overflow: auto;\n}\n.modal-wrapper--small > .modal-container[data-v-b7c7c7ca] {\n  width: 400px;\n  max-width: 90%;\n  max-height: min(90%, 100% - 2 * var(--header-height));\n}\n.modal-wrapper--normal > .modal-container[data-v-b7c7c7ca] {\n  max-width: 90%;\n  width: 600px;\n  max-height: min(90%, 100% - 2 * var(--header-height));\n}\n.modal-wrapper--large > .modal-container[data-v-b7c7c7ca] {\n  max-width: 90%;\n  width: 900px;\n  max-height: min(90%, 100% - 2 * var(--header-height));\n}\n.modal-wrapper--full > .modal-container[data-v-b7c7c7ca] {\n  width: 100%;\n  height: calc(100% - var(--header-height));\n  position: absolute;\n  top: var(--header-height);\n  border-radius: 0;\n}\n@media only screen and ((max-width: 512px) or (max-height: 400px)) {\n.modal-wrapper .modal-container[data-v-b7c7c7ca] {\n    max-width: initial;\n    width: 100%;\n    max-height: initial;\n    height: calc(100% - var(--header-height));\n    position: absolute;\n    top: var(--header-height);\n    border-radius: 0;\n}\n}\n\n/* TRANSITIONS */\n.fade-enter-active[data-v-b7c7c7ca],\n.fade-leave-active[data-v-b7c7c7ca] {\n  transition: opacity 250ms;\n}\n.fade-enter[data-v-b7c7c7ca],\n.fade-leave-to[data-v-b7c7c7ca] {\n  opacity: 0;\n}\n.fade-visibility-enter[data-v-b7c7c7ca],\n.fade-visibility-leave-to[data-v-b7c7c7ca] {\n  visibility: hidden;\n  opacity: 0;\n}\n.modal-in-enter-active[data-v-b7c7c7ca],\n.modal-in-leave-active[data-v-b7c7c7ca],\n.modal-out-enter-active[data-v-b7c7c7ca],\n.modal-out-leave-active[data-v-b7c7c7ca] {\n  transition: opacity 250ms;\n}\n.modal-in-enter[data-v-b7c7c7ca],\n.modal-in-leave-to[data-v-b7c7c7ca],\n.modal-out-enter[data-v-b7c7c7ca],\n.modal-out-leave-to[data-v-b7c7c7ca] {\n  opacity: 0;\n}\n.modal-in-enter .modal-container[data-v-b7c7c7ca],\n.modal-in-leave-to .modal-container[data-v-b7c7c7ca] {\n  transform: scale(0.9);\n}\n.modal-out-enter .modal-container[data-v-b7c7c7ca],\n.modal-out-leave-to .modal-container[data-v-b7c7c7ca] {\n  transform: scale(1.1);\n}\n.modal-mask .play-pause-icons .progress-ring[data-v-b7c7c7ca] {\n  position: absolute;\n  top: 0;\n  inset-inline-start: 0;\n  transform: rotate(-90deg);\n}\n.modal-mask .play-pause-icons .progress-ring .progress-ring__circle[data-v-b7c7c7ca] {\n  transition: 100ms stroke-dashoffset;\n  transform-origin: 50% 50%;\n  animation: progressring-b7c7c7ca linear var(--slideshow-duration) infinite;\n  stroke-linecap: round;\n  stroke-dashoffset: 94.2477796077;\n  stroke-dasharray: 94.2477796077;\n}\n.modal-mask .play-pause-icons--paused .icon-pause[data-v-b7c7c7ca] {\n  animation: breath-b7c7c7ca 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n}\n.modal-mask .play-pause-icons--paused .progress-ring__circle[data-v-b7c7c7ca] {\n  animation-play-state: paused !important;\n}\n@keyframes progressring-b7c7c7ca {\nfrom {\n    stroke-dashoffset: 94.2477796077;\n}\nto {\n    stroke-dashoffset: 0;\n}\n}\n@keyframes breath-b7c7c7ca {\n0% {\n    opacity: 1;\n}\n50% {\n    opacity: 0;\n}\n100% {\n    opacity: 1;\n}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
